import { render, staticRenderFns } from "./notverified.vue?vue&type=template&id=5bef7844&"
import script from "./notverified.vue?vue&type=script&lang=js&"
export * from "./notverified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports